export default "__VITE_ASSET__OCqQW$mn__"